// src/pages/clab-biodata-pending/components/FilterPanel.jsx
import React, { useState, useEffect } from "react";
import Icon from "components/AppIcon";
// import { recruiterService } from 'utils/supabaseServices';
// TODO: Migrate recruiterService usages to backend API

const FilterPanel = ({ filters, onFiltersChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [recruiters, setRecruiters] = useState([]);
  const [localSearch, setLocalSearch] = useState(filters.search || "");
  const [localSkill, setLocalSkill] = useState(filters.skill || "");

  // Debounce search term - wait 500ms after user stops typing
  useEffect(() => {
    // Only trigger if value actually changed
    if (localSearch === (filters.search || "")) return;

    const handler = setTimeout(() => {
      onFiltersChange((prev) => ({
        ...prev,
        search: localSearch,
      }));
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [localSearch]);

  // Debounce skill term - map to search to avoid skill filter API
  useEffect(() => {
    if (localSkill === (filters.search || "")) return;
    const handler = setTimeout(() => {
      onFiltersChange((prev) => ({
        ...prev,
        search: localSkill,
      }));
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [localSkill]);

  // Sync local values with external filters
  useEffect(() => {
    setLocalSearch(filters.search || "");
    setLocalSkill(filters.search || "");
  }, [filters.search]);

  useEffect(() => {
    let isMounted = true;

    const loadRecruiters = async () => {
      try {
        // const result = await recruiterService.getRecruiters({ status: 'active' });
        if (/* result.data && */ isMounted) {
          // setRecruiters(result.data);
        }
      } catch (error) {
      }
    };

    loadRecruiters();

    return () => {
      isMounted = false;
    };
  }, []);

  const nationalities = [
    "Bangladesh",
    "India",
    "Philippines",
    "China",
    "Pakistan",
    "Sri Lanka",
    "Nepal",
    "Myanmar",
    "Vietnam",
    "Indonesia",
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const clearAllFilters = () => {
    setLocalSearch("");
    setLocalSkill("");
    onFiltersChange({
      search: "",
      nationality: "",
      recruiter_id: "",
      date_from: "",
      date_to: "",
      skill: "",
    });
  };

  const hasActiveFilters =
    filters.search ||
    filters.nationality ||
    filters.recruiter_id ||
    filters.date_from ||
    filters.date_to;

  return (
    <div className="card">
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-text-primary">
            Search & Filter
          </h2>
          <div className="flex items-center space-x-3">
            {hasActiveFilters && (
              <button
                onClick={clearAllFilters}
                className="text-sm text-error hover:text-error-600 font-medium"
              >
                Clear All
              </button>
            )}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="flex items-center space-x-1 text-sm text-primary hover:text-primary-700 font-medium"
            >
              <span>{isExpanded ? "Less Filters" : "More Filters"}</span>
              <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={16} />
            </button>
          </div>
        </div>

        {/* Search Bar */}
        <div className="mb-4">
          <div className="relative">
            <Icon
              name="Search"
              size={20}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-secondary-400"
            />
            <input
              type="text"
              placeholder="Search by worker name, passport... (Press Enter or wait 0.5s)"
              value={localSearch}
              onChange={(e) => setLocalSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onFiltersChange((prev) => ({
                    ...prev,
                    search: localSearch,
                  }));
                }
              }}
              className="input-field pl-10 w-full"
            />
          </div>
        </div>

        {/* Basic Filters */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-text-secondary mb-2">
              Nationality
            </label>
            <select
              value={filters.nationality}
              onChange={(e) =>
                handleFilterChange("nationality", e.target.value)
              }
              className="input-field w-full"
            >
              <option value="">All Nationalities</option>
              {nationalities.map((nationality) => (
                <option key={nationality} value={nationality}>
                  {nationality}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-text-secondary mb-2">
              Skill keyword
            </label>
            <input
              type="text"
              value={localSkill}
              onChange={(e) => setLocalSkill(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onFiltersChange((prev) => ({
                    ...prev,
                    search: localSkill,
                  }));
                }
              }}
              className="input-field w-full"
              placeholder="e.g. welding, scaffolding (Press Enter or wait 0.5s)"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-secondary mb-2">
              Recruiter
            </label>
            <select
              value={filters.recruiter_id}
              onChange={(e) =>
                handleFilterChange("recruiter_id", e.target.value)
              }
              className="input-field w-full"
            >
              <option value="">All Recruiters</option>
              {recruiters.map((recruiter) => (
                <option key={recruiter.id} value={recruiter.id}>
                  {recruiter.agency_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Advanced Filters */}
        {isExpanded && (
          <div className="border-t border-secondary-200 pt-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  From Date
                </label>
                <input
                  type="date"
                  value={filters.date_from}
                  onChange={(e) =>
                    handleFilterChange("date_from", e.target.value)
                  }
                  className="input-field w-full"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  To Date
                </label>
                <input
                  type="date"
                  value={filters.date_to}
                  onChange={(e) =>
                    handleFilterChange("date_to", e.target.value)
                  }
                  className="input-field w-full"
                />
              </div>
            </div>

            {/* Quick Filter Buttons */}
            <div className="mt-4 pt-4 border-t border-secondary-200">
              <div className="flex items-center space-x-2 mb-2">
                <span className="text-sm font-medium text-text-secondary">
                  Quick Filters:
                </span>
              </div>
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => {
                    const today = new Date().toISOString().split("T")[0];
                    handleFilterChange("date_from", today);
                    handleFilterChange("date_to", today);
                  }}
                  className="px-3 py-1 text-sm rounded-full border bg-surface text-text-secondary border-secondary-300 hover:bg-secondary-50 transition-colors duration-150"
                >
                  Today's Submissions
                </button>
                <button
                  onClick={() => {
                    const weekAgo = new Date();
                    weekAgo.setDate(weekAgo.getDate() - 7);
                    handleFilterChange(
                      "date_from",
                      weekAgo.toISOString().split("T")[0]
                    );
                    handleFilterChange("date_to", "");
                  }}
                  className="px-3 py-1 text-sm rounded-full border bg-surface text-text-secondary border-secondary-300 hover:bg-secondary-50 transition-colors duration-150"
                >
                  Last 7 Days
                </button>
                <button
                  onClick={() => {
                    const monthAgo = new Date();
                    monthAgo.setMonth(monthAgo.getMonth() - 1);
                    handleFilterChange(
                      "date_from",
                      monthAgo.toISOString().split("T")[0]
                    );
                    handleFilterChange("date_to", "");
                  }}
                  className="px-3 py-1 text-sm rounded-full border bg-surface text-text-secondary border-secondary-300 hover:bg-secondary-50 transition-colors duration-150"
                >
                  Last Month
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Active Filters Display */}
        {hasActiveFilters && (
          <div className="mt-4 pt-4 border-t border-secondary-200">
            <div className="flex items-center space-x-2 mb-2">
              <span className="text-sm font-medium text-text-secondary">
                Active Filters:
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              {filters.search && (
                <span className="inline-flex items-center px-2 py-1 bg-primary-100 text-primary-800 text-xs rounded-full">
                  Search: {filters.search}
                  <button
                    onClick={() => handleFilterChange("search", "")}
                    className="ml-1 text-primary-600 hover:text-primary-800"
                  >
                    <Icon name="X" size={12} />
                  </button>
                </span>
              )}
              {filters.nationality && (
                <span className="inline-flex items-center px-2 py-1 bg-primary-100 text-primary-800 text-xs rounded-full">
                  Nationality: {filters.nationality}
                  <button
                    onClick={() => handleFilterChange("nationality", "")}
                    className="ml-1 text-primary-600 hover:text-primary-800"
                  >
                    <Icon name="X" size={12} />
                  </button>
                </span>
              )}
              {filters.recruiter_id && (
                <span className="inline-flex items-center px-2 py-1 bg-primary-100 text-primary-800 text-xs rounded-full">
                  Recruiter:{" "}
                  {recruiters.find((r) => r.id === filters.recruiter_id)
                    ?.agency_name || "Selected"}
                  <button
                    onClick={() => handleFilterChange("recruiter_id", "")}
                    className="ml-1 text-primary-600 hover:text-primary-800"
                  >
                    <Icon name="X" size={12} />
                  </button>
                </span>
              )}
              {filters.date_from && (
                <span className="inline-flex items-center px-2 py-1 bg-primary-100 text-primary-800 text-xs rounded-full">
                  From: {filters.date_from}
                  <button
                    onClick={() => handleFilterChange("date_from", "")}
                    className="ml-1 text-primary-600 hover:text-primary-800"
                  >
                    <Icon name="X" size={12} />
                  </button>
                </span>
              )}
              {filters.date_to && (
                <span className="inline-flex items-center px-2 py-1 bg-primary-100 text-primary-800 text-xs rounded-full">
                  To: {filters.date_to}
                  <button
                    onClick={() => handleFilterChange("date_to", "")}
                    className="ml-1 text-primary-600 hover:text-primary-800"
                  >
                    <Icon name="X" size={12} />
                  </button>
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterPanel;
